export const ErrorIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.00226 10.5C9.00226 11.0523 8.55454 11.5 8.00226 11.5C7.44997 11.5 7.00226 11.0523 7.00226 10.5C7.00226 9.94772 7.44997 9.5 8.00226 9.5C8.55454 9.5 9.00226 9.94772 9.00226 10.5Z"
      fill="#FF881B"
    />
    <path
      d="M7.72679 4.83333C7.33676 4.83333 7.03004 5.16668 7.06243 5.55536L7.31012 8.52768C7.32452 8.70045 7.46894 8.83333 7.6423 8.83333H8.36221C8.53558 8.83333 8.68 8.70045 8.6944 8.52768L8.94209 5.55536C8.97448 5.16668 8.66775 4.83333 8.27773 4.83333H7.72679Z"
      fill="#FF881B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.26577 1.19522C7.03356 -0.148408 8.97095 -0.148407 9.73874 1.19522L15.4412 11.1745C16.2031 12.5078 15.2403 14.1667 13.7047 14.1667H2.29983C0.764183 14.1667 -0.198549 12.5078 0.563344 11.1745L6.26577 1.19522ZM8.58109 1.85674C8.32516 1.40886 7.67936 1.40886 7.42343 1.85674L1.721 11.836C1.46704 12.2804 1.78795 12.8334 2.29983 12.8334H13.7047C14.2166 12.8334 14.5375 12.2804 14.2835 11.836L8.58109 1.85674Z"
      fill="#FF881B"
    />
  </svg>
);
